import { useState } from "react";
import { Link } from "react-router-dom";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import { states, cityStates } from "src/components/common/cityState";
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, 
    MyFormData, 
    objAscSort, 
    validURL, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function OrganizationForm({
    closeIt, 
    history, 
    keyword, 
    /* below for edit */
    organizationName, 
    website, 
    extension, 
    fax, 
    street, 
    city, 
    state, 
    country, 
    postalCode, 
    phoneNumber, 
    organizationHashKey, 
    background
}){
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const organizations = useMyStore(state => state.organizations);
    const setOrganizations = useMyStore(state => state.setOrganizations);
    const organizationDetails = useMyStore(state => state.organizationDetails);
    const setOrganizationDetails = useMyStore(state => state.setOrganizationDetails);
    //--------------------------------------------------------------------------------------------
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    //--------------------------------------------------------------------------------------------
    const [email1Invalid, setEmail1Invalid] = useState({website: website});
    const [exact, setExact] = useState(false);
    const [curState, setCurState] = useState(state);
    //--------------------------------------------------------------------------------------------
    const handleSubmit = async(e) => {
        if(exact){
            window.alert(`Duplicate Website with ${email1Invalid.organizationName}`);
            return;
        }
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        if(formData.get("website").length > 0 && !validURL(formData.get("website"))){
            window.alert("Website is invalid.");
            return;
        }
        const url = keyword === "Add"?"organizations/createOrg.php":(keyword === "Edit"?"organizations/updateOrg.php":"");
        //--------------------------------------
        setShowLoader(true);
        const res = await myAxios(url, formData);
        setShowLoader(false);
        if(!res) return;
        //--------------------------------------
        if(keyword === "Add"){
            setOrganizations([...organizations.data, res.data].sort((a, b) => objAscSort(a, b, "organizationName")));
            setOrganizationDetails(organizationHashKey, {...organizationDetails[organizationHashKey], ...res.data});
            history.push(`/${path1}/${res.data.organizationHashKey}`);
        }else if(keyword === "Edit"){
            setOrganizations(organizations.data.map(org => org.organizationHashKey === organizationHashKey?res.data:org));
            setOrganizationDetails(organizationHashKey, {...organizationDetails[organizationHashKey], ...res.data});
            history.goBack();
        }
    }
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword} 
            width = {"80rem"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div className = "cssSeperateWhenWide pl-3 mb-2">
                <div className = "flex-grow-1 mr-3">
                    <input className = "nodisplay" readOnly name = "organizationHashKey" value = {organizationHashKey || ""}/>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "organizationName" className = "font-weight-bold text-nowrap mb-0">Organization Name:</label>
                        <input className = "nodisplay" readOnly name = "prevOrganizationName" defaultValue = {organizationName || ""}/>
                        <input id = "organizationName" className = "form-control flex-grow-1 ml-3" required name = "organizationName" defaultValue = {organizationName || ""}/>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "website" className = "font-weight-bold mb-0">Website:</label>
                        <input
                            id = "website"
                            type = "url"
                            className = "form-control flex-grow-1 ml-3"
                            name = "website"
                            defaultValue = {website || ""}
                            onBlur = {async e => {
                                const target = e.currentTarget.value;
                                if(target === website){
                                    setEmail1Invalid({website: website});
                                    return;
                                }
                                if(!target){
                                    setEmail1Invalid({});
                                    return;
                                }
                                setExact(false);
                                const formData = new MyFormData();
                                formData.append("organizationHashKey", organizationHashKey || "");
                                formData.append("website", target.split("/")[2]);
                                //--------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("organizations/checkDuplicateOrg.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //--------------------------------------
                                if(res.data === ""){
                                    setEmail1Invalid({});
                                }else{
                                    setExact(target === res.data.website);
                                    setEmail1Invalid(res.data);
                                }
                            }}
                        />
                    </div>
                    {email1Invalid.organizationHashKey?
                    <div className = "mt-2">
                        <div className = "font-weight-bold text-danger">
                            Organization&nbsp;
                            {
                                exact?
                                `has already existed`:
                                `maybe exist` 
                            }&nbsp;
                            in database with&nbsp;
                            <Link to = {`/Organizations/${email1Invalid.organizationHashKey}`}>
                                {email1Invalid.organizationName}
                            </Link>
                            .
                        </div>
                    </div>
                    :null}
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "phoneNumber" className = "font-weight-bold mb-0">Business Phone:</label>
                        <Cleave
                            id = "phoneNumber"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                            className = "form-control flex-grow-1 ml-3"
                            name = "phoneNumber"
                            value = {phoneNumber || ""}
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "extension" className = "font-weight-bold mb-0">Extension:</label>
                        <input id = "extension" className = "form-control flex-grow-1 ml-3" name = "extension" defaultValue = {extension || ""}/>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "fax" className = "font-weight-bold mb-0">Fax:</label>
                        <Cleave
                            id = "fax"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                            className = "form-control flex-grow-1 ml-3"
                            name = "fax"
                            value = {fax || ""}
                            options = {{
                                blocks:[3, 3, 4], 
                                delimiter: "-", 
                                numericOnly: true, 
                            }}
                        />
                    </div>
                </div>
                <div className = "flex-grow-1 mr-3">
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "street" className = "font-weight-bold mb-0">Street:</label>
                        <input id = "street" className = "form-control flex-grow-1 ml-3" name = "street" defaultValue = {street || ""}/>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "city" className = "font-weight-bold">City:</label>
                        <select id = "city" className = "form-control flex-grow-1 ml-3" name = "city" defaultValue = {city || ""}>
                            <option value = "">Select</option>
                            {curState?cityStates[curState].map((s, i) => <option key = {i}>{s}</option>):null}
                        </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "state" className = "font-weight-bold">State:</label>
                        <select id = "state" className = "form-control flex-grow-1 ml-3" name = "state" defaultValue = {state || ""}
                            onChange = {e => {
                                setCurState(e.currentTarget.value);
                            }}
                        >
                            <option value = "">Select</option>
                            {states.map((s, i) => <option key = {i}>{s}</option> )}
                        </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "postalCode" className = "font-weight-bold">Postal Code:</label>
                        <input id = "postalCode" className = "form-control flex-grow-1 ml-3" name = "postalCode" defaultValue = {postalCode || ""}/>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "country" className = "font-weight-bold">Country:</label>
                        <input id = "country" className = "form-control flex-grow-1 ml-3" name = "country" defaultValue = {country || ""} list = "countries" autoComplete = "off"/>
                        <datalist id = "countries"><option value = {"United States"}/></datalist>
                    </div>
                </div>
                <div className = "d-flex flex-column align-items-start mt-2">
                    <label htmlFor = "background" className = "font-weight-bold mb-0">Background:</label>
                    <textarea id = "background" className = "form-control w-100 flex-grow-1" name = "background" defaultValue = {background}/>
                </div>
            </div>
        </Modal>
    )
}